import { formatViolationsAsErrors } from "../form/services";

export const emptyStringSanitizer = (params) => {
  const sanitizedParams = { ...params };

  Object.keys(sanitizedParams).forEach((key) => {
    sanitizedParams[key] =
      sanitizedParams[key] !== "" ? sanitizedParams[key] : null;
  });
  return sanitizedParams;
};

export const getOrderParams = (
  orderBy,
  orderDirection,
  flatOrderBy,
  hasSeparatedOrderByParams
) => {
  let orderByParams = {};
  if (orderBy) {
    orderByParams[orderBy] = orderDirection;
  }
  if (hasSeparatedOrderByParams) {
    return {
      orderBy: orderBy,
      orderDirection: orderDirection
    };
  }
  if (flatOrderBy) {
    return { orderBy: flatOrderBy };
  }
  return { orderBy: orderByParams };
};

export const handleOnFail = (error) => {
  const violations = error.response.data.violations;
  const errors = formatViolationsAsErrors(violations);
  error.config.onFail({ errors, error });
};
